export const uploadDocumentModalInitValue = {
  data: {
    file: undefined,
    name: '',
    date: '',
    isForAdmins: false,
    isLoading: false,
  },
  actions: {
    handleChangeFile: () => {},
    handleChangeName: () => {},
    handleChangeDate: () => {},
    handleChangeIsForAdmins: () => {},
    handleUploadDocument: () => {},
    handleCloseModal: () => {},
  },
};
